export default __webpack_public_path__ + "static/media/section-hero-overlay-2.12bdfe70.svg";